/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';

import messages from './MLRewriteContactUsPage.messages'


function MLRewriteContactUsPage(props){
    const { history, location } = props;
    const { state } = location;
    const rewrite = _.get(state, 'gwInfo.params[0]');
    const translator = useTranslator();
    const [errorMessage, setErrorMessage] = useState("")
    const policyNumber = _.get(rewrite, 'policy.policyNumber');

    useEffect(() => {
        const baseErrorString = state.baseError;
        let messageString;
        // Split strings into before and after stack trace
        const indexOfStackTrace = baseErrorString.indexOf('StackTrace_ML');
        if (indexOfStackTrace === -1) {
            messageString = baseErrorString;
        } else {
            messageString = baseErrorString.substring(0, indexOfStackTrace);
        }

        const errorMessageStringArray = messageString.split(' ');
        const outerErrorCodeIndex = messageString.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;

        if(policyNumber && outerErrorCodeNumericValue){
            setErrorMessage(translator(messages.errorNonRetry, {
                quoteNumber: policyNumber, 
                errorCode: outerErrorCodeNumericValue,
                strong: (chunks) => <strong>{chunks}</strong>,
                br: () => <br />
            }))
        }else{
            setErrorMessage(translator(messages.errorNonRetryNoParameters, {
                strong: (chunks) => <strong>{chunks}</strong>,
                br: () => <br />
            }))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onReturnToPolicyDetailsClick = () => {
        history.push(`/policies/${policyNumber}/summary`);
    };

    return(
        <div className="page-content-gpa">
            <section>
                <p>{errorMessage}</p>
            </section> 

            {policyNumber && 
                <a onClick={onReturnToPolicyDetailsClick}>
                    {translator(messages.returnToPolicyPage)}
                </a>
            }
        </div>
    )
}

export default withRouter(MLRewriteContactUsPage);